import React from 'react';
import { Checkbox } from '../../../../../components/Checkbox';
import { PdfComponentBorderProperties } from '../../../PdfComponent';
import { PdfComponentWithBorder } from '../PdfTemplateComponentBorder';

export default function PdfTemplateComponentBorderEnabled({
  component,
  updateBorder,
}: {
  component: PdfComponentWithBorder;
  updateBorder: (border: Partial<PdfComponentBorderProperties>) => void;
}) {
  return <Checkbox label='Border' value={component.border.enabled} onChange={enabled => updateBorder({ enabled })} />;
}
